import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import { get, isEmpty, isNil } from 'lodash';
import { Chip, Grid, TextField, Typography } from '@material-ui/core';
import { injectIntl, IntlShape } from 'react-intl';
import moment from 'moment-timezone';
import { StyledActionButton } from 'components/Buttons/styled-component';
import NoticeDeficiencyDialog from 'containers/ExpertExpertise/Dialogs/NoticeDeficiencyDialog';
import Document from 'components/Document';
import ActionButton from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/ActionButton';
import CustomAccordion from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/CustomAccordion';
import expertiseExpertiseIcon from 'images/expert-expertise-icon.svg';
import messages from 'containers/ExpertExpertise/messages';
import { COLORS } from 'constants/design';
import { Container } from 'containers/ExpertExpertise/FillExpertise/style';
import { handleOpenDocument } from 'services/utils';
import { translate } from 'containers/services/translate';
import {
  renderChipLabel,
  renderColor,
  renderTitleAccordion,
} from 'containers/ExpertExpertise/Recap/utils';
import {
  MISSION_EXPERISE_VICTIM_STATUS,
  MISSION_POSTPONE_STATUS,
} from 'containers/data-structure';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { getValueByCode as getValueByCodeSagis } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import { getValueByCode } from 'containers/common/LegalProceedings/JudgementAdd/Recap/utils';
import LabelValue from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/ExpertReport/LabelValue';
import { isMissionPostPoneContainsNullDate } from 'containers/ExpertExpertise/Recap/utils';
export interface RecapNoticeDeficiencyProps {
  intl: IntlShape;
  title: string;
  missionPostPone: any;
  isManager: boolean;
  openValidationModal?: Function;
  openRejectionModal?: Function;
  setSelectedNotice?: Function;
  requestUpdateMissionPostPone: Function;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  sagis_code: any;
  missionPostPoneExpertise: any;
  requestGetDocByDocumentumId: Function;
}

const RecapNoticeDeficiency: FC<RecapNoticeDeficiencyProps> = (
  props,
): JSX.Element => {
  const { title } = props;
  const [noticeToEdit, setNoticeToEdit] = useState({});
  const [openNoticeDeficiencyDialog, setOpenNoticeDeficiencyDialog] = useState(
    false,
  );
  const listings = useSelector((state: any) =>
    get(state.toJS(), ['appContainer', 'listings'], []),
  );

  return (
    <Container>
      {!isEmpty(props.missionPostPone) &&
        props.missionPostPone.map((element: any, index: number) => (
          <CustomAccordion
            title={
              (
                <Grid container direction="row" justify="space-between">
                  <Grid item>{renderTitleAccordion(element, title)}</Grid>
                  <Grid item>
                    {!props.isManager &&
                      get(element.missionPostPone, 'status') ===
                        MISSION_POSTPONE_STATUS.REJECTED &&
                      get(element.missionPostPone, 'createdBy') ===
                        props.sagis_code && (
                        <StyledActionButton
                          title={translate(messages.updateTitle, props)}
                          lefticon={
                            <EditIcon
                              style={{
                                height: '14px',
                                width: '14px',
                                marginRight: '8px',
                              }}
                            />
                          }
                          onClick={() => {
                            setOpenNoticeDeficiencyDialog(true);
                            setNoticeToEdit(element);
                          }}
                        />
                      )}
                  </Grid>
                </Grid>
              ) as any
            }
            textColor={COLORS.ACCORDION_TEXT_BLUE}
            bgColor={COLORS.ACCORDION_BG_BLUE}
            image={expertiseExpertiseIcon}
          >
            <Grid container spacing={2} alignItems={'center'}>
              {!props.sagis_code && (
                <Grid item xs={12}>
                  <Grid container spacing={3} alignItems="center">
                    <Grid item xs={4}>
                      <LabelValue
                        title={
                          translate(messages.referenceMisionTitle, props) + ':'
                        }
                        value={get(element, 'mission.reference')}
                      />
                    </Grid>

                    {get(element, 'mission.courtFileNumber') && (
                      <Grid item xs={4}>
                        <LabelValue
                          title={
                            translate(messages.courtFileNumberTitle, props) +
                            ':'
                          }
                          value={get(element, 'mission.courtFileNumber')}
                        />
                      </Grid>
                    )}

                    <Grid item xs={4}>
                      <LabelValue
                        title={
                          translate(messages.procedureTypeTitle, props) + ':'
                        }
                        value={
                          getValueByCode(
                            get(element, 'mission.procedureNatureId'),
                            get(listings, 'procedureNature', []),
                          ) as any
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}
              <Grid item xs={2}>
                <TextField
                  label={translate(messages.reason, props)}
                  value={element?.missionPostPone?.reason}
                  className="input"
                  fullWidth
                />
              </Grid>
              {((!isEmpty(props.missionPostPoneExpertise) &&
                isMissionPostPoneContainsNullDate(
                  props.missionPostPoneExpertise,
                )) ||
                !isNil(element?.mission?.missionDate)) && (
                <Grid item xs={2}>
                  <TextField
                    label={translate(messages.missionDate, props)}
                    value={moment(element?.mission?.missionDate).format(
                      'DD/MM/YYYY',
                    )}
                    className="input"
                    fullWidth
                  />
                </Grid>
              )}
              {props.isManager &&
                (!element?.missionPostPone?.status ||
                  element?.missionPostPone?.status ===
                    MISSION_EXPERISE_VICTIM_STATUS.PENDING) && (
                  <Grid item xs={4}>
                    <ActionButton
                      handleOpenDialogValidation={() => {
                        props.openValidationModal &&
                          props.openValidationModal();
                        props.setSelectedNotice &&
                          props.setSelectedNotice(element);
                      }}
                      handleOpenDialogRejection={() => {
                        props.openRejectionModal && props.openRejectionModal();
                        props.setSelectedNotice &&
                          props.setSelectedNotice(element);
                      }}
                      shouldDisplayAppreciation={false}
                    />
                  </Grid>
                )}
              <Grid item xs={props.isManager && 12}>
                <section>
                  <div style={{ marginTop: '10px' }}>
                    <Document
                      name={get(element, 'name', '')}
                      type={get(element, 'type', '')}
                      icon={
                        <VisibilityIcon
                          className="consult"
                          onClick={handleOpenDocument(
                            element,
                            props.requestGetDocByDocumentumId,
                          )}
                        />
                      }
                    />
                  </div>
                </section>
              </Grid>
              {get(element?.missionPostPone, 'status') !==
                MISSION_POSTPONE_STATUS.PENDING &&
                get(element?.missionPostPone, 'decidedBy') && (
                  <Grid item xs={12}>
                    <Grid item>
                      <Typography
                        style={{
                          color: COLORS.LIGHT_GREY,
                          fontWeight: 400,
                          fontSize: '13px',
                        }}
                      >
                        {translate(messages.decidedBy, props)}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        style={{
                          color: COLORS.TEXT_BLACK,
                          fontWeight: 400,
                          fontSize: '13px',
                        }}
                      >
                        {get(element?.missionPostPone, 'decidedBy')}
                      </Typography>
                    </Grid>
                  </Grid>
                )}
              <Grid item xs={12}>
                <Typography
                  style={{
                    color: COLORS.LIGHT_GREY,
                    fontWeight: 400,
                    fontSize: '13px',
                  }}
                >
                  {translate(messages.statusMissionPostPoneTitle, props)}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Chip
                  style={{
                    backgroundColor: renderColor(
                      element?.missionPostPone?.status,
                    ),
                    color: COLORS.WHITE,
                    fontWeight: 700,
                  }}
                  label={renderChipLabel(element?.missionPostPone?.status)}
                />
              </Grid>
              {get(element?.missionPostPone, 'status') ===
                MISSION_POSTPONE_STATUS.REJECTED &&
                get(element?.missionPostPone, 'rejectReason') && (
                  <>
                    <Grid item>
                      <Typography
                        style={{
                          color: COLORS.LIGHT_GREY,
                          fontWeight: 400,
                          fontSize: '13px',
                        }}
                      >
                        {translate(messages.reason, props) + ':'}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        style={{
                          color: COLORS.TEXT_BLACK,
                          fontWeight: 400,
                          fontSize: '13px',
                        }}
                      >
                        {get(element?.missionPostPone, 'rejectReason')}
                      </Typography>
                    </Grid>
                  </>
                )}

              {get(element?.missionPostPone, 'comment') && (
                <>
                  <Grid item>
                    <Typography
                      style={{
                        color: COLORS.LIGHT_GREY,
                        fontWeight: 400,
                        fontSize: '13px',
                      }}
                    >
                      {translate(messages.comment, props) + ':'}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      style={{
                        color: COLORS.TEXT_BLACK,
                        fontWeight: 400,
                        fontSize: '13px',
                      }}
                    >
                      {get(element?.missionPostPone, 'comment')}
                    </Typography>
                  </Grid>
                </>
              )}
              {get(element?.missionPostPone, 'createdBy') && (
                <>
                  <Grid item>
                    <Typography
                      style={{
                        color: COLORS.LIGHT_GREY,
                        fontWeight: 400,
                        fontSize: '13px',
                      }}
                    >
                      {translate(messages.createdByTitle, props)}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      style={{
                        color: COLORS.TEXT_BLACK,
                        fontWeight: 400,
                        fontSize: '13px',
                      }}
                    >
                      {getValueByCodeSagis(
                        get(element?.missionPostPone, 'createdBy') as string,
                        get(listings, 'intervenants'),
                      )}
                    </Typography>
                  </Grid>
                </>
              )}
            </Grid>
            <NoticeDeficiencyDialog
              open={openNoticeDeficiencyDialog}
              onClose={() => setOpenNoticeDeficiencyDialog(false)}
              validateDialog={props.requestUpdateMissionPostPone}
              uploadDocument={props.uploadDocument}
              uploadedDocument={props.uploadedDocument}
              recap={noticeToEdit}
              resetUploadedDocument={props.resetUploadedDocument}
              listings={listings}
              mission={get(noticeToEdit, 'mission')}
              missionPostPoneExpertise={props.missionPostPoneExpertise}
            />
          </CustomAccordion>
        ))}
    </Container>
  );
};

export default injectIntl(RecapNoticeDeficiency);
